// src/pages/UserDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import { db } from "../firebaseConfig";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  orderBy,
  query,
  updateDoc,
  serverTimestamp,
  setDoc,
  where, 
  limit 
} from "firebase/firestore";

export default function UserDetail() {
  const { userId } = useParams();
  const navigate = useNavigate();


  const [user, setUser] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [songs, setSongs] = useState([]);
  const [lyrics, setLyrics] = useState([]);
  const [showLyrics, setShowLyrics] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const cargarTodo = async () => {
      try {
        setLoading(true);
        setError("");

        // 1) Usuario
        const userRef = doc(db, "usuarios", userId);
        const userSnap = await getDoc(userRef);
        if (!userSnap.exists()) {
          setError("El usuario no existe.");
          return;
        }
        const uData = userSnap.data();
        setUser({
          id: userSnap.id,
          ...uData,
          fechaRegistro: uData.fechaRegistro?.toDate?.() || null,
        });

        // 2) Wallet: usuarios/{uid}/wallet/main
        const walletRef = doc(db, "usuarios", userId, "wallet", "main");
        const walletSnap = await getDoc(walletRef);
        if (walletSnap.exists()) {
          const wData = walletSnap.data();
          setWallet({
            ...wData,
            updatedAt: wData.updatedAt?.toDate?.() || null,
          });
        }

        // 3) Canciones
        const songsRef = query(
          collection(db, "usuarios", userId, "canciones"),
          orderBy("fechaCreacion", "desc")
        );
        const songsSnap = await getDocs(songsRef);
        const songsList = songsSnap.docs.map((d) => {
          const s = d.data();
          return {
            id: d.id,
            titulo: s.titulo || "",
            estilo: s.estilo || "",
            taskId: s.taskId || "",
            coverUrl: s.coverUrl || "",
            coverUrl02: s.coverUrl02 || "",
            fechaCreacion: s.fechaCreacion?.toDate?.() || null,
          };
        });
        setSongs(songsList);

        // 4) Letras
        const lyricsRef = query(
          collection(db, "usuarios", userId, "letras"),
          orderBy("fechaCreacion", "desc")
        );
        const lyricsSnap = await getDocs(lyricsRef);
        const lyricsList = lyricsSnap.docs.map((d) => {
          const l = d.data();
          return {
            id: d.id,
            titulo: l.titulo || "",
            letra: l.letra || "",
            fechaCreacion: l.fechaCreacion?.toDate?.() || null,
          };
        });
        setLyrics(lyricsList);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarTodo();
  }, [userId]);

  const handleOpenSong = (songId) => {
    navigate(`/songs/${userId}/${songId}`);
  };

  const editarWalletRapido = async () => {
    const code = prompt("Código para editar wallet:");
    if (code !== "1234") return alert("Código incorrecto.");

    const nuevoBalance = prompt("Nuevo balance:", String(wallet?.balance ?? 0));
    if (nuevoBalance == null) return;

    const primerPagoTxt = prompt("primerPago (true/false):", String(!!wallet?.primerPago));
    if (primerPagoTxt == null) return;

    const balanceNumber = Number(nuevoBalance);
    if (!Number.isFinite(balanceNumber) || balanceNumber < 0) {
      return alert("Balance inválido");
    }

    const primerPagoBool = primerPagoTxt.trim().toLowerCase() === "true";

    const walletRef = doc(db, "usuarios", userId, "wallet", "main");
    await updateDoc(walletRef, {
      balance: balanceNumber,
      primerPago: primerPagoBool,
      updatedAt: serverTimestamp(),
    });

    // refrescar UI local
    setWallet((prev) => ({
      ...(prev || {}),
      balance: balanceNumber,
      primerPago: primerPagoBool,
      updatedAt: new Date(),
    }));

    alert("✅ Wallet actualizada");
  };

  const irAlChatConUsuario = async () => {
    try {
      if (!userId) return;

      // 1) Buscar chat existente (ajusta "chats" y "userId" si tus campos se llaman diferente)
      const q = query(
        collection(db, "chats"),
        where("userId", "==", userId),
        limit(1)
      );

      const snap = await getDocs(q);

      if (!snap.empty) {
        const chatId = snap.docs[0].id;
        navigate(`/chats/${chatId}`);
        return;
      }

      // 2) Si no existe, crearlo
      const chatRef = doc(collection(db, "chats"));
      await setDoc(chatRef, {
        userId: userId,
        userName: user?.nombre || user?.name || "",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        lastMessage: "",
        lastMessageAt: null,
        status: "open"
      });

      navigate(`/chats/${chatRef.id}`);
    } catch (e) {
      console.error(e);
      alert("No se pudo abrir el chat.");
    }
  };




  if (loading) return <p>Cargando usuario...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!user) return <p>No se encontró el usuario.</p>;

  return (
    <div>
      <Link to="/users">← Volver a usuarios</Link>

      {/* DATOS DEL USUARIO */}
      <h1 style={{ marginTop: 16 }}>Usuario</h1>
      <p>
        <strong>ID:</strong> {user.id}
      </p>
      <p>
        <strong>Nombre:</strong> {user.nombre || "-"}
      </p>
      <p>
        <strong>Correo:</strong> {user.correo || "-"}
      </p>
      <p>
        <strong>Fecha registro:</strong>{" "}
        {user.fechaRegistro
          ? user.fechaRegistro.toLocaleString()
          : "-"}
      </p>
      <p>
        <strong>Calificación promedio:</strong>{" "}
        {typeof user.calificacionPromedio === "number"
          ? user.calificacionPromedio.toFixed(1)
          : "-"}
      </p>

      <button
        onClick={irAlChatConUsuario}
        style={{
          padding: "10px 14px",
          borderRadius: 10,
          border: "1px solid #ddd",
          background: "#fff",
          cursor: "pointer",
          fontWeight: 700
        }}
      >
        Abrir chat con este usuario
      </button>

      <button
        onClick={() => navigate(`/crear-desde-usuario/${user.id}`)}
        style={{
          padding: "10px 14px",
          borderRadius: 10,
          border: "1px solid #ddd",
          background: "#fff",
          cursor: "pointer",
          fontWeight: 700
        }}
      >
        Crear canción al Usuario
      </button>


      

      {/* WALLET */}
      <hr style={{ margin: "16px 0" }} />
      <h2>Wallet</h2>
      <button onClick={editarWalletRapido}>Editar wallet</button>
      {wallet ? (
        <div>
          <p>
            <strong>Balance:</strong> {wallet.balance}
          </p>
          <p>
            <strong>Primer pago:</strong>{" "}
            {wallet.primerPago ? "Sí" : "No"}
          </p>
          <p>
            <strong>Última actualización:</strong>{" "}
            {wallet.updatedAt
              ? wallet.updatedAt.toLocaleString()
              : "-"}
          </p>
        </div>
      ) : (
        <p>Este usuario no tiene wallet.</p>
      )}

      // dentro del return, cerca del header de Usuario
      <div style={{ marginTop: 12, marginBottom: 16 }}>
        <button onClick={() => navigate(`/users/${user.id}/notify`)}>
          Enviar notificación a este usuario
        </button>
      </div>


      {/* CANCIONES */}
      <hr style={{ margin: "16px 0" }} />
      <h2>Canciones</h2>
      <p style={{ marginBottom: 8 }}>Total: {songs.length}</p>

      <div style={{ overflowX: "auto", marginBottom: 16 }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 14,
          }}
        >
          <thead>
            <tr>
              <th style={th}>Título</th>
              <th style={th}>Estilo</th>
              <th style={th}>Task ID</th>
              <th style={th}>Cover 1</th>
              <th style={th}>Cover 2</th>
              <th style={th}>Fecha creación</th>
            </tr>
          </thead>
         <tbody>
          {songs.map((s, idx) => (
            <tr
              key={s.id}
              onClick={() => handleOpenSong(s.id)}          // ⬅️ navegar al detalle
              style={{
                cursor: "pointer",                          // ⬅️ mano de clic
                backgroundColor: idx % 2 === 0 ? "#ffffff" : "#e9e9e9",
              }}
            >
              <td style={{ ...td, ...clamp2, maxWidth: 220 }}>
                {s.titulo || "(sin título)"}
              </td>
              <td style={td}>{s.estilo}</td>
              <td style={{ ...td, ...clamp2, maxWidth: 220 }}>
                {s.taskId || "-"}
              </td>
              <td style={td}>{s.coverUrl ? "Sí" : "No"}</td>
              <td style={td}>{s.coverUrl02 ? "Sí" : "No"}</td>
              <td style={td}>
                {s.fechaCreacion
                  ? s.fechaCreacion.toLocaleString()
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>

          </table>
          {lyrics.length === 0 && (
            <p style={{ marginTop: 8 }}>No hay letras para este usuario.</p>
          )}
        </div>
      )}
    </div>
  );
}

const th = {
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  padding: "8px",
  backgroundColor: "#f5f5f5",
};

const td = {
  borderBottom: "1px solid #eee",
  padding: "8px",
};

const clamp2 = {
  display: "-webkit-box",
  WebkitLineClamp: 2, // máximo 2 líneas
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};
